var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"c-title",class:{
    'c-title--2': _vm.level === 2,
    'c-title--3': _vm.level === 3
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }